import React, { useState } from 'react';
import './StarLeaderBoardTopInt.css';
export default function StarLeaderBoardTopInt({ data, info }) {
	const [showInfow, setShowInfo] = useState(false);
	return (
		<div className='star-cont'>
			<div className="starLeaderboardInt">
				
				<div className='starLeaderboardContainer'>
					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/birscndddd.svg' 
							// className="starLeaderboardInt__ranklogo2"
							className='starLeaderboard1'
						/>
						<img src={data[1]?.orgLogo} className="starLeaderboardInt__rank2" />
						<div className="starLeaderboardInt__institue2">{data[1]?.orgName}</div>
					</div>

					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/crwn.svg'
							className="starLeaderboardInt__crown"
						/>
					</div>

					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/birfirsttt.svg' 
							className="starLeaderboardInt__yellow" 
						/>
						<img src={data[0]?.orgLogo} className="starLeaderboardInt__rank1"/>
						<div className="starLeaderboardInt__institue1">{data[0]?.orgName}</div>
					</div>

					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/birthirddd.svg' 
							// className="starLeaderboardInt__ranklogo3" 
							className='starLeaderboard2'
						/>
						<img src={data[2]?.orgLogo} className="starLeaderboardInt__rank3" />
						<div className="starLeaderboardInt__institue3">{data[2]?.orgName}</div>
					</div>
				</div>
				



				{/* <img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/secongsvggg.svg' className="starLeaderboardInt__orange" /> */}
				{/* <img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/1.svg' className="starLeaderboardInt__ranklogo1" /> */}
				{/* <img src={data[1]?.orgLogo} className="starLeaderboardInt__rank2" /> */}
			

				{/* <img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/Group 1116599170.svg' className="starLeaderboardInt__ranklogo3" /> */}

				
				{/* <div className="starLeaderboardInt__institue1-point">
					{data[0]?.points}
					<span className="starLeaderboardInt__institue1-point-text">
						Points
					</span>
				</div>
				<div className="starLeaderboardInt__institue2-point">
					{data[1]?.points}
					<span className="starLeaderboardInt__institue2-point-text">
						Points
					</span>
				</div>
				<div className="starLeaderboardInt__institue3-point">
					{data[2]?.points}
					<span className="starLeaderboardInt__institue3-point-text">
						Points
					</span>
				</div> */}
				{showInfow && <div className="starLeaderboardInt__infoText">{info}</div>}
				{/* <img
					className="starLeaderboardInt__infoIcon"
					src={information}
					onClick={() => setShowInfo(!showInfow)}
				/> */}
				{/* <div className="starLeaderboardInt__institue2-point-text">points</div>
            <div className="leaderBoardTopInt__institue3-point-text">points</div> */}
			</div>
		</div>
	);
}
